import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { NgxLoadingModule } from "ngx-loading";
import { CustomerBoookingHeaderComponent } from "./customer-boooking-header/customer-boooking-header.component";
import { FooterPoweredByImageComponent } from "./footer-powered-by-image/footer-powered-by-image.component";
import { BookingDetailComponent } from "./booking-detail/booking-detail.component";
import { InquiryFormComponent } from "./inquiry-form/inquiry-form.component";
import { LoaderComponent } from "./loader/loader.component";

@NgModule({
  imports: [CommonModule, FormsModule, NgxLoadingModule],
  exports: [
    LoaderComponent,
    CustomerBoookingHeaderComponent,
    FooterPoweredByImageComponent,
    BookingDetailComponent,
    InquiryFormComponent,
  ],
  declarations: [
    CustomerBoookingHeaderComponent,
    FooterPoweredByImageComponent,
    BookingDetailComponent,
    InquiryFormComponent,
    LoaderComponent,
  ],
  providers: [],
})
export class SharedModule {}
